export interface AwsModuleLoadResult {
  appModule?: Record<string, unknown>;
  contactModule?: Record<string, unknown>;
  voiceModule?: Record<string, unknown>;
  packageErrors: string[];
}

export async function loadAwsModules(): Promise<AwsModuleLoadResult> {
  const packageErrors: string[] = [];

  const [appResult, contactResult, voiceResult] = await Promise.allSettled([
    import('@amazon-connect/app'),
    import('@amazon-connect/contact'),
    import('@amazon-connect/voice'),
  ]);

  const result: AwsModuleLoadResult = { packageErrors };

  if (appResult.status === 'fulfilled') {
    result.appModule = appResult.value as Record<string, unknown>;
  } else {
    packageErrors.push(`@amazon-connect/app: ${String(appResult.reason)}`);
  }

  if (contactResult.status === 'fulfilled') {
    result.contactModule = contactResult.value as Record<string, unknown>;
  } else {
    packageErrors.push(
      `@amazon-connect/contact: ${String(contactResult.reason)}`,
    );
  }

  if (voiceResult.status === 'fulfilled') {
    result.voiceModule = voiceResult.value as Record<string, unknown>;
  } else {
    packageErrors.push(`@amazon-connect/voice: ${String(voiceResult.reason)}`);
  }

  return result;
}

export function getExport<T = unknown>(
  moduleObject: Record<string, unknown> | undefined,
  names: string[],
): T | undefined {
  if (!moduleObject) {
    return undefined;
  }

  for (const name of names) {
    const value = moduleObject[name];
    if (value !== undefined) {
      return value as T;
    }
  }

  return undefined;
}
